import React, { useState } from 'react';
import { base44 } from '@/api/base44Client';
import { Loader2, CheckCircle2 } from 'lucide-react';

export default function NewsletterSignup({ variant = 'footer' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const isSection = variant === 'section';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      await base44.entities.NewsletterSubscriber.create({ email, source: variant });
      setStatus('success');
      setEmail('');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className={`flex items-center gap-2 ${isSection ? 'justify-center' : ''}`}>
        <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
        <span className="text-sm text-white/70">You're subscribed — watch your inbox.</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={isSection ? 'w-full' : ''}>
      <div className="flex">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 min-w-0 bg-[#1a1a1f] border border-white/10 px-3 py-3 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-primary/50"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-wide px-5 transition-colors disabled:opacity-50 flex items-center justify-center"
        >
          {status === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : 'JOIN'}
        </button>
      </div>
      {status === 'error' && (
        <p className="text-red-400 text-xs mt-2">Something went wrong. Please try again.</p>
      )}
      <p className="text-white/20 text-[10px] mt-2">No spam. Unsubscribe anytime.</p>
    </form>
  );
}